import React from "react";

function DeleteIcon({ color }) {
  return (
    <span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="11.5"
          fill="white"
          stroke={color ?? "#3C3C3C"}
        />
        <path
          d="M16.8571 8.14286H14.2857V7.28571C14.2857 6.94467 14.1502 6.61771 13.9092 6.37653C13.668 6.13546 13.341 6 13 6H11.2857C10.9447 6 10.6177 6.13546 10.3765 6.37653C10.1355 6.6177 9.99999 6.94467 9.99999 7.28571V8.14286H7.42857C7.27541 8.14286 7.13393 8.22455 7.0574 8.35714C6.98087 8.48973 6.98087 8.65313 7.0574 8.78571C7.13393 8.9183 7.27541 9 7.42857 9H7.85714V16.7143C7.85714 17.0553 7.99259 17.3823 8.23367 17.6235C8.47484 17.8645 8.80181 18 9.14285 18H15.1429C15.4839 18 15.8109 17.8645 16.052 17.6235C16.2931 17.3823 16.4286 17.0553 16.4286 16.7143V9H16.8571C17.0103 9 17.1518 8.9183 17.2283 8.78571C17.3048 8.65312 17.3048 8.48973 17.2283 8.35714C17.1518 8.22456 17.0103 8.14286 16.8571 8.14286ZM10.8571 7.28571C10.8571 7.17207 10.9023 7.06301 10.9826 6.98265C11.063 6.9023 11.1721 6.85714 11.2857 6.85714H13C13.1136 6.85714 13.2227 6.9023 13.3031 6.98265C13.3834 7.06301 13.4286 7.17207 13.4286 7.28571V8.14286H10.8571V7.28571ZM15.5714 16.7143C15.5714 16.8279 15.5263 16.937 15.4459 17.0173C15.3656 17.0977 15.2565 17.1429 15.1429 17.1429H9.14285C9.0292 17.1429 8.92015 17.0977 8.83979 17.0173C8.75943 16.937 8.71428 16.8279 8.71428 16.7143V9H15.5714V16.7143Z"
          fill={color ?? "#3C3C3C"}
        />
        <path
          d="M13.4286 10.7144C13.3149 10.7144 13.2059 10.7595 13.1255 10.8399C13.0452 10.9202 13 11.0293 13 11.1429V15.0001C13 15.1532 13.0817 15.2947 13.2143 15.3712C13.3469 15.4478 13.5103 15.4478 13.6429 15.3712C13.7754 15.2947 13.8571 15.1532 13.8571 15.0001V11.1429C13.8571 11.0293 13.812 10.9202 13.7316 10.8399C13.6513 10.7595 13.5422 10.7144 13.4286 10.7144Z"
          fill={color ?? "#3C3C3C"}
        />
        <path
          d="M10.8573 10.7144C10.7436 10.7144 10.6346 10.7595 10.5542 10.8399C10.4739 10.9202 10.4287 11.0293 10.4287 11.1429V15.0001C10.4287 15.1532 10.5104 15.2947 10.643 15.3712C10.7756 15.4478 10.939 15.4478 11.0716 15.3712C11.2042 15.2947 11.2859 15.1532 11.2859 15.0001V11.1429C11.2859 11.0293 11.2407 10.9202 11.1603 10.8399C11.08 10.7595 10.9709 10.7144 10.8573 10.7144Z"
          fill={color ?? "#3C3C3C"}
        />
      </svg>
    </span>
  );
}

export default DeleteIcon;
